import React, { useEffect } from "react";
import MuiTable from "../MuiTable/MuiTable";
import Button from "@material-ui/core/Button";
import "./SuccessJobSummary.css";

const SuccessJobSummary = ({ disableInitial }) => {
  useEffect(() => {
    disableInitial(false);
  }, []);
  const columns = [
    "Job Title",
    "Class",
    "Curriculum",
    "Experience",
    "Salary offered",
  ];
  const data = [
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
    ["Science teacher", "1-5", "CBSE", "6+ years", "$10,000 - $15,000"],
  ];
  return (
    <div>
      <div className="order-placed-confirmation-box">
        <div className="order-success-logo"></div>
        <div className="order-success-title">
          Your order has been confirmed!
        </div>
        <div className="order-success-title-md">
          Our Admin will review and publish your jobs within 24 hours.
        </div>
        <div className="order-success-title-sm">
          The order confirmation with details of your order has been sent to
          your email address.
        </div>
      </div>
      <div className="order-detials-grid">
        <div className="order-line-at-top"></div>
        <div className="salary-table">
          <MuiTable columns={columns} data={data} />
        </div>
        <div className="backto">
          <Button
            variant="contained"
            className="backto-btn"
            style={{ color: "white" }}
          >
            Back to Jobs List
          </Button>
        </div>
        <div className="order-detials">
          <div className="order-sm-title"></div>
          <div className="order-title-item1">Order detials</div>
          <div className="order-title-item2"></div>
          <div className="order-title-item3">
            <div className="order-list-sm-title">Order Number</div>
            <div className="order-list-sm-price">JP98601090</div>
          </div>
          <div className="order-title-item4">
            <div className="order-list-sm-title">Orderd On</div>
            <div className="order-list-sm-price">5 Sep 2021</div>
          </div>
          <div className="order-title-item5">
            <div className="order-list-sm-title">Created Job Post</div>
            <div className="order-list-sm-price">04</div>
          </div>
          <div className="order-title-item6">
            <div className="order-list-sm-title">Total Posts Purchased</div>
            <div className="order-list-sm-price">06</div>
          </div>
          <div className="order-title-dotted-line"></div>
          <div className="order-title-item7">
            <div className="order-list-sm-title">Total amount</div>
            <div className="order-list-sm-price">₹ 26,500</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessJobSummary;
